export default __webpack_public_path__ + "static/media/Haubepinguin.29f81d8b.jpg";